import { useSession } from "providers/SessionProvider";
import React from "react";
import { NavLink } from "react-router-dom";
import LanguageSelect from "./LanguageSelect";
import { useTranslation } from "react-i18next";

const Layout = (props) => {
    const { user } = useSession();
    const { t } = useTranslation();

    const handleLogout = (e) => {
        localStorage.clear();
    };

    if (user.role === "cci") {
        return (
            <>
                <header>
                    <ul>
                        <li>
                            <NavLink to="/number-detail">{t("number_detail")}</NavLink>
                        </li>
                        <li>
                            <NavLink to="/un-sub">{t("unsubscription")}</NavLink>
                        </li>
                        <li>
                            <NavLink to="/login" onClick={handleLogout}>
                                {t("logout")}
                            </NavLink>
                        </li>
                        {/* <li style="float:right"><a class="active" href="#about">About</a></li> */}
                    </ul>
                    <LanguageSelect />
                </header>
                {/* <div> */}
                {props.children}
                {/* </div> */}
            </>
        );
    } else if (user.role === "admin") {
        return (
            <>
                <header>
                    <ul>
                        <li>
                            <NavLink to="/home">Home</NavLink>
                        </li>
                        <li>
                            <NavLink to="/upload-base">Upload Base</NavLink>
                        </li>
                        <li>
                            <NavLink to="/upload-sms-base">Upload SMS Base</NavLink>
                        </li>
                        <li>
                            <NavLink to="/send-sms">Send SMS</NavLink>
                        </li>
                        <li>
                            <NavLink to="/number-detail">{t("number_detail")}</NavLink>
                        </li>
                        <li>
                            <NavLink to="/un-sub">{t("unsubscription")}</NavLink>
                        </li>
                        <li>
                            <NavLink to="/mis">MIS</NavLink>
                        </li>
                        <li>
                            <NavLink to="/login" onClick={handleLogout}>
                                {t("logout")}
                            </NavLink>
                        </li>
                        {/* <li style="float:right"><a class="active" href="#about">About</a></li> */}
                    </ul>
                    <LanguageSelect />
                </header>
                {/* <div> */}
                {props.children}
                {/* </div> */}
            </>
        );
    } else {
        return (
            <>
                <header>
                    <ul>
                        <li>
                            <NavLink to="/login" onClick={handleLogout}>
                                {t("logout")}
                            </NavLink>
                        </li>
                    </ul>
                    <LanguageSelect />
                </header>
                <p>User role not found!</p>
            </>
        );
    }
};

export default Layout;
